import React from 'react';
import { bool, shape, string } from 'prop-types';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

import TextField from '../FormFields/TextField';
import Switch from '../FormFields/Switch';

import classes from './ModifyRuleFieldset.module.css';

const EditRuleFieldset = ({
    disabled,
    errors,
    isLoading,
    onBlur,
    onChange,
    readOnly,
    touched,
    values
}) => (
    <>
        <TextField
            autoComplete="off"
            disabled={readOnly}
            errors={errors.name}
            label="Rule Name"
            name="name"
            onBlur={onBlur}
            onChange={onChange}
            touched={touched.name}
            value={values.name}
        />
        <List>
            <ListItem disableGutters>
                <ListItemText
                    classes={{
                        primary: classes.listItemText
                    }}
                >
                    Enabled
                </ListItemText>
                <ListItemSecondaryAction>
                    <Switch
                        checked={values.enabled}
                        disabled={disabled || isLoading}
                        name="enabled"
                        onBlur={onBlur}
                        onChange={onChange}
                    />
                </ListItemSecondaryAction>
            </ListItem>
        </List>
    </>
);

EditRuleFieldset.defaultProps = {
    disabled:  false,
    isLoading: false,
    errors:    {},
    readOnly:  false,
    touched:   {},
    values:    {}
};

EditRuleFieldset.propTypes = {
    disabled: bool,
    errors:   shape({
        name: string
    }),
    isLoading: bool,
    readOnly:  bool,
    touched:   shape({
        name: bool
    }),
    values: shape({
        name: string
    })
};

export default EditRuleFieldset;
